import React, { useEffect, useState } from "react";
import "../Pages/card.scss";
import kitchen from "../assets/17kv/04.jpg";
import hall from "../assets/17kv/05.jpg";
import bedroom from "../assets/17kv/013.jpg";
import study from "../assets/17kv/025.jpg";
import childroom from "../assets/17kv/018.1.jpg";
import bathroom from "../assets/17kv/031.1.jpg";
import wardrobe from "../assets/17kv/027.1.jpg";
import hallway from "../assets/17kv/010.jpg";
import Card from "../Components/Card";
import { TagButton, TagButtonAll } from "../Components/TagButtons";
import Gallery from "../Components/GalleryViewer";

import flat from "../Components/data.json";
import { useCallback } from "react";
import { Translation } from "react-i18next";

const images = flat;

const cardsData = [
  {
    img: kitchen,
    alt: "kitchen",
    titleKey: "portfolio.title-1",
    descKey: "portfolio.description",
    tagName: "кухня",
  },
  {
    img: hall,
    alt: "hall",
    titleKey: "portfolio.title-2",
    descKey: "portfolio.description-2",
    tagName: "гостиная",
  },
  {
    img: bedroom,
    alt: "bedroom",
    titleKey: "portfolio.title-3",
    descKey: "portfolio.description-3",
    tagName: "спальня",
  },
  {
    img: childroom,
    alt: "childroom",
    titleKey: "portfolio.title-4",
    descKey: "portfolio.description-4",
    tagName: "детская",
  },
  {
    img: study,
    alt: "study",
    titleKey: "portfolio.title-5",
    descKey: "portfolio.description-5",
    tagName: "кабинет",
  },
  {
    img: bathroom,
    alt: "bathroom",
    titleKey: "portfolio.title-6",
    descKey: "portfolio.description-6",
    tagName: "ванная",
  },
  {
    img: wardrobe,
    alt: "wardrobe",
    titleKey: "portfolio.title-7",
    descKey: "portfolio.description-7",
    tagName: "гардеробная",
  },
  {
    img: hallway,
    alt: "hallway",
    titleKey: "portfolio.title-8",
    descKey: "portfolio.description-8",
    tagName: "прихожая",
  },
];

function Flat() {
  const [tag, setTag] = useState("all");
  const [filteredImages, setFilteredImages] = useState([]);

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  useEffect(() => {
    tag === "all"
      ? setFilteredImages(images.flat)
      : setFilteredImages(images.flat.filter((image) => image.tag === tag));
  }, [tag]);

  useEffect(() => {
    if (isViewerOpen) {
      document.body.classList.add("viewer-open");
    } else {
      document.body.classList.remove("viewer-open");
    }
  }, [isViewerOpen]);

  return (
    <Translation>
      {(t) => (
        <div
          style={{
            fontWeight: "bold",
            fontFamily: "Montserrat, sans-serif",
            textAlign: "center",
            color: "#46669c",
          }}
        >
          <h5
            className="mt-4 mb-2"
            style={{ fontWeight: "600", marginLeft: "1em", marginRight: "1em" }}
          >
            {t(["portfolio.adres"])}
            {/*  Visualization of the interior of the apartment. Krivoy Rog, 42
          Kashtanova str. */}
          </h5>
          <div className="wrapper mt-4">
            {cardsData.map((card, index) => (
              <div className="card" key={index}>
                <Card
                  img={card.img}
                  alt={card.alt}
                  title={t([card.titleKey])}
                  description={t([card.descKey])}
                />

                <div onClick={() => openImageViewer(0)}>
                  <TagButton
                    name={card.tagName}
                    tagactive={tag === card.tagName}
                    handleSetTag={setTag}
                  />
                </div>
              </div>
            ))}
          </div>

          <div onClick={() => openImageViewer(0)}>
            <TagButtonAll
              name="all"
              tagactive={tag === "all" ? true : false}
              handleSetTag={setTag}
            />
          </div>

          <div>
            {isViewerOpen && (
              <Gallery
                images={filteredImages}
                startIndex={currentImage}
                onClose={closeImageViewer}
              />
            )}
          </div>
        </div>
      )}
    </Translation>
  );
}

export default Flat;
